import { FC } from 'react';
import Close from '../../assets/close.png';
import { Trans } from 'react-i18next';
import { ConfirmationModalV2Props } from './confirmationModalV2.type';
import ButtonSpinner from '../../assets/buttonLoading/buttonLoading';
import { getIdAttributes } from '../../utils/helper';
import Button from '../button/button';

export const idPrefix: string = 'confirmation-modal';

export const ConfirmationModalV2: FC<ConfirmationModalV2Props> = (props) => {
  if (!props.isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[rgb(0,0,0,0.3)] bg-no-repeat bg-left-top bg-origin-padding opacity-100 backdrop-blur-[2px]"
      {...getIdAttributes(idPrefix, 'overlay')}
    >
      <div
        className={`relative flex flex-col justify-between sm:min-w-[600px] sm:min-h-[400px] gap-2 p-4 bg-white rounded-lg shadow-lg`}
        {...getIdAttributes(idPrefix, 'container')}
      >
        <img
          onClick={props.onClose}
          src={Close}
          alt="Close Layout"
          className="text-[#151740] h-3 w-3 cursor-pointer self-end"
          {...getIdAttributes(idPrefix, 'close-button')}
        />

        <div className="flex flex-col gap-3 max-w-[400px] self-center">
          {props.title && (
            <p className="text-center text-lg text-[#151740] font-bold">
              <Trans i18nKey={props.title} />
            </p>
          )}
          <p
            className="text-center text-sm text-gray-700"
            {...getIdAttributes(idPrefix, 'message')}
          >
            {props.message}
          </p>

          {props.showConfirmButton && (
            <div
              className="mt-6 flex justify-center"
              {...getIdAttributes(idPrefix, 'button-container')}
            >
              <Button
                className="min-w-[170px] py-2 rounded-full text-sm bg-THEME_COLOR hover:bg-THEME_HOVER_COLOR"
                onClick={props.onConfirm}
                data-testid={`${idPrefix}-confirm-button`}
              >
                {props.isLoading ? (
                  <ButtonSpinner />
                ) : (
                  <Trans i18nKey="common.yes" />
                )}
              </Button>
            </div>
          )}
        </div>
        <p className="text-[#6B688B] text-xs max-w-[400px] self-center break-words text-center">
          <Trans i18nKey={props.note} components={{ bold: <strong /> }} />
        </p>
      </div>
    </div>
  );
};
